import { Avatar, Box, Typography } from '@mui/material'
import React from 'react'
import RemovePayrollModal from './RemovePayrollModal'
import ClaimBadge from './ClaimBadge'

const AdjustedCardList = ({ data, onView, time_id, claimSummary }) => {
  const { name, position, salary, avatar } = data
  return (
    <Box display="flex" padding={2} borderBottom={1} borderColor="gray-line.main">
      <Avatar
        sx={{
          minWidth: '45px',
          height: '45px',
          mr: 2,
        }}
        src={avatar}
      >
        {/* {`${name.split(' ')[0][0]}${name.split(' ')[1][0]}`} */}
      </Avatar>
      <Box display="flex" flexDirection="column" width="100%">
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-around"
          sx={{ minHeight: '45px' }}
        >
          <Typography variant="body1">{name}</Typography>
          <Typography variant="body2" color="light-gray-text.main">
            {position}
          </Typography>
          <ClaimBadge summary={claimSummary} />
        </Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" marginTop="10px">
          <Box display="flex" alignItems="center">
            <Typography variant="body1" color="light-gray-text.main" sx={{ mr: 1 }}>
              Net pay
            </Typography>
            <Typography
              variant="subtitle1"
              color="yellow-01.main"
            >{`RM ${salary?.nett}`}</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Typography
              variant="subtitle1"
              onClick={() => onView(data)}
              color="alternate.main"
              sx={{ cursor: 'pointer', textDecoration: 'underline', mr: 2 }}
            >
              View
            </Typography>
            <RemovePayrollModal deets={data} time_id={time_id}>
              <Typography
                variant="subtitle1"
                color="error.main"
                sx={{ cursor: 'pointer', textDecoration: 'underline' }}
              >
                Remove
              </Typography>
            </RemovePayrollModal>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default AdjustedCardList
